/**
 * Paths served by the Expo app rather than this React app. Both are served
 * from kudable.com by one nginx, split by path — so navigating to them has to
 * be a full page load, not a react-router transition, or the browser stays
 * inside this bundle and renders NotFound.
 */
const APP_HOME_PATH = '/home';
const APP_SIGN_IN_PATH = '/login';

/**
 * Where the Expo app keeps its JWT on web. `mobile/src/services/secure-storage`
 * falls back to localStorage under this key when `Platform.OS === 'web'`, and
 * `mobile/src/services/api` reads it from there — so the two apps share a
 * session without any handoff.
 */
const AUTH_TOKEN_KEY = 'kudable_auth_token';

const hasSession = (): boolean => {
  try {
    return Boolean(window.localStorage.getItem(AUTH_TOKEN_KEY));
  } catch {
    // Safari in private mode throws on localStorage access rather than
    // returning null. Treat that as signed out instead of breaking the button.
    return false;
  }
};

/**
 * Straight into the app when there is already a session, otherwise to sign-in.
 *
 * The check has to happen here: `app/(app)/_layout.tsx` has no auth guard, so
 * an unauthenticated visitor sent to /home would get an app shell with no
 * provider rather than being redirected. A stale token is still handled — the
 * app's axios interceptor clears it on the first 401 and bounces to sign-in.
 */
export const goToApp = () => {
  window.location.href = hasSession() ? APP_HOME_PATH : APP_SIGN_IN_PATH;
};

/**
 * Registration and sign-in are the same screen: the OTP flow creates the
 * account when the identifier is not recognised, so there is no separate
 * signup route in the Expo app.
 */
export const goToSignUp = () => {
  window.location.href = APP_SIGN_IN_PATH;
};
